const splitError = function (gqlError) {
  // graphQL Errors are filled on non 5xx responses
  // for 5xx networkError contains the raw result
  const { graphQLErrors, networkError } = gqlError
  const errorList = []

  if (graphQLErrors && Array.isArray(graphQLErrors)) {
    graphQLErrors.forEach(e => errorList.push(e))

    // only use network error part when no gql error exists
    // this is the case for 5xx errors
    if (networkError && networkError.result && networkError.result.errors &&
        Array.isArray(networkError.result.errors) && graphQLErrors.length === 0) {
      networkError.result.errors.forEach(e => errorList.push(e))
    }
  }

  return errorList
}

export { splitError }
